import { render, staticRenderFns } from "./UiDatePreset.vue?vue&type=template&id=74a0234e&"
import script from "./UiDatePreset.vue?vue&type=script&lang=ts&"
export * from "./UiDatePreset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports